/* PAT Datenschutz — Einwilligung getrennt nach Kategorie.
   Rundgang-Befund 3 (25.08.2026). Ersetzt die vorherige Fassung von
   assets/pat-datenschutz.js
   (unverändert seit tom&pat 7.2, MD5 7ea03f94e3b412b9cacc5d59d9b5ea1d).

   Was sich gegenüber der Vorfassung ändert:
   - Bisher: Lehnte der Besucher NUR Statistik ODER NUR Werbung ab, wurden die
     Cookies und Speicherwerte BEIDER Kategorien gelöscht — eine gemeinsame
     Namensliste (Zeilen 10-11), ein gemeinsames aufraeumen() ohne Parameter
     (Zeilen 45-63), ausgelöst über ein ODER in Zeile 70.
   - Jetzt: Statistik (_ga, _gid, _ga_*, _clck, _clsk) und Werbung (_gcl_*) sind
     getrennte Cookie-Listen; bei den Speicherwerten kommt clarity* zur Statistik
     und _gac* zur Werbung. Gelöscht wird nur die abgelehnte
     Kategorie. clarity('consent', false) läuft nur noch bei abgelehnter
     Statistik, weil Clarity kein Werbeprodukt ist.
   - _gac_* zählt zur Werbung, nicht zur Statistik: Der Wert enthält die gclid
     und geht an Google Ads. Deshalb der Lookahead _ga(?!c) in der
     Statistik-Regel und _gac im Werbe-Muster (Fiete-Befund 28.08.2026).
   - Teil b (Hinweiszeilen an App-Blöcken): Der Hinweis am Benachrichtigen-Block
     („Alert me when available“) ist am 28.08.2026 entfallen, weil die App
     deinstalliert ist und im Theme kein solches Formular mehr existiert.
     Unverändert bleiben die Hinweiszeilen am Judge.me-Bewertungsformular und am
     Widerrufsformular von 401layers.

   Warum sicher:
   - Die Datei löscht ausschließlich Browserdaten; sie lädt keine fremden
     Skripte und setzt keine Tracking-Werte.
   - Lehnt der Besucher beides ab, passiert exakt dasselbe wie vorher.
   - Lehnt er nur eine Kategorie ab, bleibt jeder Wert der erlaubten Kategorie
     stehen; von der abgelehnten Kategorie wird alles geloescht, was die Listen
     und Muster unten erfassen (Altlueckenhinweis am Ende gilt weiter).
   - Alles bleibt in derselben IIFE; keine andere Theme-Datei greift auf die
     internen Funktionen zu.

   Bekannte Altluecke, bewusst NICHT mit geaendert: _gat, _gat_gtag_UA_*, _gaexp,
   __utm* und das Cookie _gac_* werden als Cookie von keiner Fassung erfasst — das
   war vorher so und bleibt so, damit diese Runde nur den Befund behebt.

   tom&pat 10.2 (09.10.2026): Teil c unten setzt die Express-Knöpfe von Shopify erst nach
   Zustimmung „Personalisierung“ ein und nimmt sie bei Widerruf wieder heraus. Erst dann
   lädt Shopify Inhalte von PayPal/Google; „Warum sicher“ oben gilt für die Teile a und b.
  tom&pat 10.3 (10.10.2026): Die Knöpfe der Warenkorb-Schublade kommen erst beim ersten Öffnen der Schublade. */
(function () {
  "use strict";

  var DATENSCHUTZ = '/policies/privacy-policy';

  /* ---------- a) Cookies aufraeumen, getrennt nach Kategorie ---------- */
  var STATISTIK = { namen: ["_ga", "_gid", "_clck", "_clsk"], praefixe: ["_ga_"] };
  var WERBUNG   = { namen: [], praefixe: ["_gcl_"] };
  var STATISTIK_SPEICHER = /^(_clck|_clsk|clarity|_ga(?!c))/i;
  var WERBUNG_SPEICHER = /^(_gcl|_gac)/i;
  var DOMAINS = ["", location.hostname, "." + location.hostname];

  function domainVarianten(host) {
    var teile = host.split(".");
    var liste = [];
    for (var i = 0; i < teile.length - 1; i++) {
      liste.push("." + teile.slice(i).join("."));
      liste.push(teile.slice(i).join("."));
    }
    return liste;
  }

  function loeschen(name) {
    var pfade = ["/", location.pathname];
    var domains = DOMAINS.concat(domainVarianten(location.hostname));
    for (var p = 0; p < pfade.length; p++) {
      for (var d = 0; d < domains.length; d++) {
        document.cookie =
          encodeURIComponent(name) +
          "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=" + pfade[p] +
          (domains[d] ? "; domain=" + domains[d] : "");
      }
    }
  }

  function passtZu(name, kategorie) {
    if (kategorie.namen.indexOf(name) !== -1) return true;
    for (var i = 0; i < kategorie.praefixe.length; i++) {
      if (name.indexOf(kategorie.praefixe[i]) === 0) return true;
    }
    return false;
  }

  function aufraeumen(statistikWeg, werbungWeg) {
    document.cookie.split(";").forEach(function (roh) {
      var name = roh.split("=")[0].trim();
      if (!name) return;
      if (statistikWeg && passtZu(name, STATISTIK)) loeschen(name);
      if (werbungWeg && passtZu(name, WERBUNG)) loeschen(name);
    });
    // Clarity legt zusaetzlich Werte im lokalen Speicher ab.
    try {
      ["localStorage", "sessionStorage"].forEach(function (art) {
        var speicher = window[art];
        if (!speicher) return;
        Object.keys(speicher).forEach(function (schluessel) {
          if (statistikWeg && STATISTIK_SPEICHER.test(schluessel)) speicher.removeItem(schluessel);
          if (werbungWeg && WERBUNG_SPEICHER.test(schluessel)) speicher.removeItem(schluessel);
        });
      });
    } catch (e) {}
    if (statistikWeg && window.clarity && typeof window.clarity === "function") {
      try { window.clarity("consent", false); } catch (e) {}
    }
  }

  function pruefen() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;
    var analyse = typeof cp.analyticsProcessingAllowed === "function" ? cp.analyticsProcessingAllowed() : true;
    var werbung = typeof cp.marketingAllowed === "function" ? cp.marketingAllowed() : true;
    var statistikWeg = analyse === false;
    var werbungWeg = werbung === false;
    if (statistikWeg || werbungWeg) aufraeumen(statistikWeg, werbungWeg);
  }

  document.addEventListener("visitorConsentCollected", pruefen);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (fehler) { if (!fehler) pruefen(); }
    );
  }
  window.setTimeout(pruefen, 2000);

  /* ---------- b) Hinweiszeilen an den App-Bloecken ---------- */
  function hinweis(text) {
    var p = document.createElement("p");
    p.className = "tp-datenschutzhinweis tp-datenschutzhinweis--app";
    p.innerHTML = text + ' <a href="' + DATENSCHUTZ + '">Datenschutzerkl&auml;rung</a>.';
    return p;
  }

  function setzen(container, kennung, text, davor) {
    if (!container || container.dataset["tp" + kennung] === "1") return;
    container.dataset["tp" + kennung] = "1";
    var zeile = hinweis(text);
    if (davor) container.parentNode.insertBefore(zeile, container);
    else container.appendChild(zeile);
  }

  function hinweiseSetzen() {
    // Judge.me Bewertungsformular
    document.querySelectorAll(".jdgm-form, .jdgm-write-rev-link, .jdgm-rev-widg").forEach(function (el) {
      var ziel = el.classList.contains("jdgm-form") ? el : null;
      if (ziel) setzen(ziel, "Judge", "Mit dem Absenden stimmen Sie der Veröffentlichung Ihrer Bewertung mit Vornamen zu.", false);
    });

    // Widerrufsformular unseres Partners
    document.querySelectorAll("iframe[src*='401layers'], iframe[src*='widerruf'], [class*='eu-widerruf'] iframe").forEach(function (el) {
      setzen(el, "Widerruf", "Das Formular stellt unser Partner 401layers UG bereit.", true);
    });
  }

  function start() { hinweiseSetzen(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  window.setTimeout(start, 1500);
  window.setTimeout(start, 4000);

  /* ---------- c) tom&pat 10.2 (Theo, 09.10.2026, Rundgang Aufgaben 58 + 60): Express-Knöpfe erst nach Zustimmung ----------
     Lenny (09.10.2026, KI Agents/Legal-Lenny/Arbeitsbereich/express-datenschutz-2026-10-09.md): Die Express-Knöpfe
     (PayPal, Google Pay, Apple Pay, Shop Pay) laden fremde Skripte und speichern Kennungen im Browser. Deshalb erst nach
     Zustimmung „Personalisierung“ (Kategorie preferences). Produktseite, feste Leiste und Schublade liefern die
     Shopify-Knöpfe nur als Datenblock (Base64) am Rahmen [data-tp-express] aus; der Rahmen ist bis zum Einsetzen
     ausgeblendet (data-tp-express-wartet, tom-pat-84.css). Ohne Zustimmung steht also kein Knopf-Element in der Seite und
     Shopify lädt weder PayPal noch Google Pay; der normale Kaufknopf bleibt unberührt.
     - Zustimmung da (beim Laden oder später im Banner): Knöpfe einsetzen, ohne Neuladen. Shopify zeichnet nachträglich
       eingesetzte Knöpfe selbst. Die feste Leiste bekommt ihren Knopf erst, wenn sie zum ersten Mal erscheint (beim Laden
       nur ein PayPal-Rahmen). Neu aufgebaute Schubladen-Füße (cart-drawer.js) werden nachgezogen.
     - Keine Zustimmung, „Ablehnen“ oder Widerruf: Knöpfe wieder heraus, Rahmen wieder ausgeblendet, PayPal-Einträge im
       Speicher von tom-pat.de löschen (Art. 7 Abs. 3 DSGVO). Cookies fremder Seiten (z. B. NID auf google.com) kann die
       Seite nicht löschen; das steht in der Datenschutzerklärung.
     - Solange Shopifys Zustimmungs-Schnittstelle nicht geladen ist, passiert nichts (keine Knöpfe). */

  // EINZIGE Stelle für die nötige Banner-Kategorie (Lenny 09.10.2026: "preferences" = „Personalisierung“).
  // Mehrere Kategorien mit Komma trennen, dann müssen alle erlaubt sein (z. B. "preferences,marketing").
  var EXPRESS_KATEGORIE = "preferences";
  var KATEGORIE_API = {
    preferences: "preferencesProcessingAllowed",
    marketing: "marketingAllowed",
    analytics: "analyticsProcessingAllowed",
    sale_of_data: "saleOfDataAllowed"
  };
  var KATEGORIE_EREIGNIS = {
    preferences: "preferencesAllowed",
    marketing: "marketingAllowed",
    analytics: "analyticsAllowed",
    sale_of_data: "saleOfDataAllowed"
  };
  var PAYPAL_SPEICHER = /^__paypal/;
  // Merker „dieser Browser hat Personalisierung erlaubt“: Nur damit hält das Snippet beim nächsten Aufbau den Platz der
  // Knöpfe frei (kein Nachrutschen). Wird nur mit dieser Zustimmung gesetzt und bei „Ablehnen“/Widerruf gelöscht.
  var MERKER = "tp-express-platz";
  var expressStand = null;
  var expressBeobachter = null;
  var widerrufVerbunden = false;

  function merker(setzen) {
    try { if (setzen) window.localStorage.setItem(MERKER, "1"); else window.localStorage.removeItem(MERKER); } catch (e) {}
  }
  function platzFreigeben() {
    document.querySelectorAll("[data-tp-express-platz]").forEach(function (r) { r.removeAttribute("data-tp-express-platz"); });
  }

  // true = erlaubt, false = nicht erlaubt, null = noch unbekannt (Schnittstelle nicht geladen).
  function expressErlaubt(detail) {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    var kategorien = EXPRESS_KATEGORIE.split(",");
    var gezaehlt = 0;
    for (var i = 0; i < kategorien.length; i++) {
      var k = kategorien[i].trim();
      if (!k) continue;
      var wert;
      if (detail && typeof detail[KATEGORIE_EREIGNIS[k]] === "boolean") wert = detail[KATEGORIE_EREIGNIS[k]];
      else if (cp && typeof cp[KATEGORIE_API[k]] === "function") wert = cp[KATEGORIE_API[k]]();
      else if (cp) return false;
      else return null;
      if (wert !== true) return false;
      gezaehlt++;
    }
    return gezaehlt > 0;
  }

  function dekodieren(daten) {
    var roh = window.atob(daten);
    var bytes = new Uint8Array(roh.length);
    for (var i = 0; i < roh.length; i++) bytes[i] = roh.charCodeAt(i);
    return new TextDecoder("utf-8").decode(bytes);
  }

  function leisteVon(rahmen) {
    return rahmen.getAttribute("data-tp-express") === "leiste" ? rahmen.closest(".sticky-atc-bar") : null;
  }

  // Feste Leiste: erst einsetzen, wenn sie einmal gezeigt wurde (Klasse sticky-atc-bar--show aus sticky-atc-bar.js).
  // Der Beobachter meldet sich im selben Durchlauf, noch bevor die Leiste gezeichnet wird.
  function leisteBereit(rahmen) {
    var leiste = leisteVon(rahmen);
    if (!leiste) return true;
    if (leiste.classList.contains("sticky-atc-bar--show")) leiste.setAttribute("data-tp-leiste-gezeigt", "");
    if (leiste.hasAttribute("data-tp-leiste-gezeigt")) return true;
    if (!leiste.tpExpressWache) {
      leiste.tpExpressWache = new MutationObserver(function () {
        if (!leiste.classList.contains("sticky-atc-bar--show")) return;
        leiste.tpExpressWache.disconnect();
        leiste.tpExpressWache = null;
        leiste.setAttribute("data-tp-leiste-gezeigt", "");
        if (expressErlaubt() === true) expressEinsetzen(rahmen);
      });
      leiste.tpExpressWache.observe(leiste, { attributes: true, attributeFilter: ["class"] });
    }
    return false;
  }

  // tom&pat 10.3 (Theo, 10.10.2026, Rundgang Aufgabe 64, Fiete nach dem Livegang 10.2): Schublade wie die Leiste.
  // Mit Zustimmung und vollem Korb lud bisher jede Seite schon bei geschlossener Schublade einen zweiten PayPal-Rahmen
  // und Google Pay (390 px: 2 PayPal-Rahmen, 3 Aufrufe pay.google.com). Jetzt setzt die Seite die Schubladen-Knöpfe erst
  // ein, wenn die Schublade in dieser Seite zum ersten Mal offen ist (Ereignis „open“ von drawer-component in global.js,
  // nach „In den Warenkorb“ oder über das Warenkorb-Symbol). Danach wie bisher: Ein neu aufgebauter Fuß (cart-drawer.js)
  // bekommt seine Knöpfe sofort. Ohne Zustimmung ändert sich nichts.
  var schubladeGeoeffnet = false;
  function schubladeBereit(rahmen) {
    if (rahmen.getAttribute("data-tp-express") !== "schublade") return true;
    if (schubladeGeoeffnet) return true;
    var schublade = rahmen.closest("drawer-component");
    if (!schublade) return true;
    if (schublade.hasAttribute("open")) schubladeGeoeffnet = true;
    return schubladeGeoeffnet;
  }
  // „open“ steigt nicht auf; deshalb in der Abfangphase am Dokument hören (wie pat-barrierefrei.js Teil d).
  document.addEventListener("open", function (e) {
    var schublade = e.target;
    if (schubladeGeoeffnet || !schublade || !schublade.querySelector || !schublade.querySelector("[data-tp-express='schublade']")) return;
    schubladeGeoeffnet = true;
    if (expressErlaubt() === true) wartendeEinsetzen();
  }, true);

  function expressEinsetzen(rahmen) {
    if (!rahmen.isConnected || !rahmen.hasAttribute("data-tp-express-wartet")) return;
    var daten = rahmen.getAttribute("data-tp-express-daten");
    if (!daten || !leisteBereit(rahmen) || !schubladeBereit(rahmen)) return;
    var html;
    try { html = dekodieren(daten); } catch (e) { return; }
    var bereich = document.createRange();
    bereich.selectNodeContents(rahmen);
    rahmen.textContent = "";
    rahmen.appendChild(bereich.createContextualFragment(html));
    rahmen.removeAttribute("data-tp-express-wartet");
    rahmen.removeAttribute("data-tp-express-platz");
    // Rückfall: Shopifys Knopf-Skript fehlt auf dieser Seite noch -> Shopify lädt es selbst nach.
    var pb = window.Shopify && window.Shopify.PaymentButton;
    if (pb && typeof pb.init === "function" && window.customElements &&
        !window.customElements.get("shopify-accelerated-checkout") &&
        !window.customElements.get("shopify-accelerated-checkout-cart")) {
      try { pb.init(); } catch (e) {}
    }
  }

  function expressEntfernen(rahmen) {
    if (rahmen.hasAttribute("data-tp-express-wartet")) return;
    rahmen.setAttribute("data-tp-express-wartet", "");
    rahmen.textContent = "";
  }

  function wartendeEinsetzen() {
    document.querySelectorAll("[data-tp-express][data-tp-express-wartet][data-tp-express-daten]").forEach(expressEinsetzen);
  }

  function paypalSpeicherLoeschen() {
    ["localStorage", "sessionStorage"].forEach(function (art) {
      try {
        var speicher = window[art];
        if (!speicher) return;
        var weg = [];
        for (var i = 0; i < speicher.length; i++) {
          var schluessel = speicher.key(i);
          if (schluessel && PAYPAL_SPEICHER.test(schluessel)) weg.push(schluessel);
        }
        weg.forEach(function (schluessel) { speicher.removeItem(schluessel); });
      } catch (e) {}
    });
  }

  // Widerruf in derselben Seite: Das schon geladene PayPal-Skript bleibt im Speicher und schickt beim Verlassen der
  // Seite noch Protokolldaten an paypal.com (gemessen 09.10.2026: 2 Aufrufe). Nach dem Widerruf werden Aufrufe der Seite
  // an die Zahlungsdienste deshalb nicht mehr abgeschickt. Nur in dieser Seite, nur diese Ziele, und nur bis zur
  // nächsten Zustimmung; auf neu geladenen Seiten ohne Zustimmung lädt ohnehin nichts von dort.
  var ZAHLDIENSTE = /^https?:\/\/([^\/?#]+\.)?(paypal\.com|paypalobjects\.com|pay\.google\.com|play\.google\.com)([\/?#:]|$)/i;
  var sperreAktiv = false;
  var sperreGebaut = false;
  function zielVon(eingabe) {
    if (typeof eingabe === "string") return eingabe;
    if (eingabe && typeof eingabe.url === "string") return eingabe.url;
    if (eingabe && typeof eingabe.href === "string") return eingabe.href;
    return String(eingabe || "");
  }
  function gesperrt(ziel) {
    if (!sperreAktiv) return false;
    try { return ZAHLDIENSTE.test(new URL(zielVon(ziel), location.href).href); } catch (e) { return false; }
  }
  function sperreBauen() {
    if (sperreGebaut) return;
    sperreGebaut = true;
    if (navigator.sendBeacon) {
      var beacon = navigator.sendBeacon;
      navigator.sendBeacon = function (ziel) { return gesperrt(ziel) ? true : beacon.apply(navigator, arguments); };
    }
    if (window.fetch) {
      var holen = window.fetch;
      window.fetch = function (ziel) {
        return gesperrt(ziel) ? Promise.reject(new TypeError("tom&pat: nach Widerruf gesperrt")) : holen.apply(this, arguments);
      };
    }
    if (window.XMLHttpRequest) {
      var oeffnen = XMLHttpRequest.prototype.open;
      var senden = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (methode, ziel) {
        this.tpGesperrt = gesperrt(ziel);
        return oeffnen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.tpGesperrt && sperreAktiv) return;
        return senden.apply(this, arguments);
      };
    }
  }

  function expressPruefen(ereignis) {
    var erlaubt = expressErlaubt(ereignis && ereignis.detail);
    if (erlaubt === null) return;
    var vorher = expressStand;
    expressStand = erlaubt;
    if (erlaubt) {
      sperreAktiv = false;
      merker(true);
      wartendeEinsetzen();
      // Neu eingefügte Rahmen (Schubladen-Fuß nach Hinzufügen/Mengenwechsel, Neuaufbau der Schublade) nachziehen.
      if (!expressBeobachter && window.MutationObserver && document.body) {
        expressBeobachter = new MutationObserver(function (eintraege) {
          for (var i = 0; i < eintraege.length; i++) {
            var neu = eintraege[i].addedNodes;
            for (var j = 0; j < neu.length; j++) {
              if (neu[j].nodeType === 1) { wartendeEinsetzen(); return; }
            }
          }
        });
        expressBeobachter.observe(document.body, { childList: true, subtree: true });
      }
      return;
    }
    if (expressBeobachter) { expressBeobachter.disconnect(); expressBeobachter = null; }
    merker(false);
    platzFreigeben();
    document.querySelectorAll("[data-tp-express]").forEach(expressEntfernen);
    paypalSpeicherLoeschen();
    // Widerruf in dieser Seite: Aufrufe an die Zahlungsdienste sperren, PayPal-Speicher später noch zweimal nachsehen.
    if (vorher === true) {
      sperreBauen();
      sperreAktiv = true;
      window.setTimeout(paypalSpeicherLoeschen, 1000);
      window.setTimeout(paypalSpeicherLoeschen, 4000);
      if (!widerrufVerbunden) {
        widerrufVerbunden = true;
        window.addEventListener("pagehide", function () { if (sperreAktiv) paypalSpeicherLoeschen(); });
      }
    }
  }

  document.addEventListener("visitorConsentCollected", expressPruefen);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (fehler) { if (!fehler) expressPruefen(); }
    );
  }
  expressPruefen();
  window.setTimeout(function () { expressPruefen(); }, 2000);
  // Schnittstelle nach 5 s immer noch nicht da (z. B. blockiert): freigehaltenen Platz wieder abgeben.
  window.setTimeout(function () { if (expressStand === null) platzFreigeben(); }, 5000);
})();
